module.exports = __webpack_public_path__ + "static/media/inviteSet.8b3e9c01.svg";